import { css, cva } from '@/styled-system/css';

export const containerStyles = css.raw({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'space-between',
  bottom: '400',
  left: '50%',
  transform: 'translateX(-50%)',
});

export const dotRecipe = cva({
  base: {
    width: '400',
    height: '400',
    border: '4px solid {colors.border.onImpact.neutral}',
    borderRadius: '50%',
    padding: '0',
    cursor: 'pointer',
  },
  variants: {
    isActive: {
      true: {
        backgroundColor: 'border.accent.brand.hero',
      },
      false: {
        backgroundColor: 'border.subtle',
      },
    },
  },
});
